export const USER_USAGE = 'PAB-2250-admin-fe-user-usage-stats';
export const LEGACY_SITE = 'PAB-2452-use-legacy-site';
